import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import App from "./App.vue";
import { router } from "@/router";
import { useAuthStore } from "@/stores/auth";
import "./styles/main.css";

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        // Dark theme retired — selector kept for PrimeVue but won't match anything.
        darkModeSelector: '[data-theme="__never__"]',
        cssLayer: false,
      },
    },
  });

  document.documentElement.setAttribute("data-theme", "light");

  // Auth init handles ?code= return from Cognito and silent refresh.
  // Must complete BEFORE we register the router — otherwise the router's
  // initial navigation fires (with auth.isSignedIn=false) during our await
  // for the token exchange, the home guard redirects to /signin, and even
  // though the token lands a moment later we're already stuck on /signin.
  const auth = useAuthStore();
  try {
    await auth.init();
  } catch (err) {
    console.error("auth init failed:", err);
  }

  app.use(router);
  await router.isReady();
  app.mount("#app");
}

bootstrap();
